exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ZB8ngZpJomuIuS51q423B {\n  padding-bottom: 16px;\n}\n\n.zroXlkY2tZEwPbi8_OX18 {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--heavy-warning-color);\n}\n", ""]);

// Exports
exports.locals = {
	"field": "_3ZB8ngZpJomuIuS51q423B",
	"warningText": "zroXlkY2tZEwPbi8_OX18"
};